import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { BracketUpdate, GetTournamentTeamMatch, TournamentBarcketId, TournamentUpdatePlayerMatchDate, TournamentUpdatePlayerMatchScore, TournamentUpdateTeamDate, TournamentUpdateTeamScore } from "../../redux/auth-reducer/auth-service";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import { toast } from "react-toastify";
import * as icons from 'react-bootstrap-icons';
import { Button, Card, Col, Form, ListGroup, Modal, Row, Tab, Tabs } from "react-bootstrap";
import { DatePicker } from "rsuite";
import dayjs from "dayjs";
import { Footer } from "../../Footer";

export const TestBracket = (props) => {
  const [roundData, setRoundData] = useState([]);
  const [dataSide, setDataSide] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editModeByIndex, setEditModeByIndex] = useState("");
  const [firstMatchIdItem, setFirstMatchIdItem] = useState();
  const [scondMtachId, setScondMtachId] = useState();
  const [secondsId, setSecondsId] = useState();
  const [count, setCount] = useState(0);
  const [scoreData, setScoreData] = useState([])
  const [dataListItem, setDataListItem] = useState([]);
  const [show, setShow] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [matchIdScore, setMatchIdScore] = useState([]);
  const [startMatch, setStartMatch] = useState()
  const { id } = useParams();
  const [dateValid, setDateValid] = useState(true);
  const [tournamentIdScore, setTournamentIdScore] = useState()
  const [dataId, setDataId] = useState()
  const [teamData, setTeamData] = useState([])
  const [showDate, setShowDate] = useState(false);
  const [noBracketshow, setNoBracketshow] = useState(false);
  const [roundMatchData, setRoundMatchData] = useState(null);
  const [selectedListItem, setSelectedListItem] = useState(null);
  const [startNoBracketMatch, setStartNoBracketMatch] = useState(null)
  const [scoreNoBracket, setScoreNoBracket] = useState("")
  const [noBracketshowDate, setNoBracketshowDate] = useState(false)
  const [validated, setValidated] = useState(false);
  const [dateUpdate, setDateUpdate] = useState();
  const [isCheckedNoBracket, SetIsCheckedNoBracket] = useState(false);
  const [teamDataLen, setTeamDataLen] = useState()
  const [dataList, setDataList] = useState({
    leftTeamScore: null,
    rightTeamScore: null,

  });
  useEffect(() => {
    roundData?.map((item) => {
      // {item?.tournamentId};
      setTournamentIdScore(item?.tournamentId);

      setMatchIdScore(item?.matchId)

    })
  })

  const handleNoBracketDateUpdate = async (tournamentId) => {


    if (!dateUpdate) {
      setDateValid(false);
      return; // Exit if no date is selected
    }




    const data =
    {
      "tournamentId": tournamentId,
      "matchStartDate": dateUpdate
    }
    await TournamentUpdatePlayerMatchDate(data).then((res) => {
      if (res?.data?.status === true) {
        setDateValid(true);
        toast.success(res?.data?.message);
        setDateValid(true);
        setCount(count + 1);
        setNoBracketshowDate(false)
      }
      else {
        setDateValid(true);
        toast.error(res?.data?.message);
      }
    })
  }
  const handelNoBracketDate = (e) => {
    setDateValid(true);
    // setStartNoBracketMatch(e); // Set the selected date
    // Update the state with the new date
    setDateUpdate(e); // Assuming this is for another state update

  }





  const handleNoBracketCheckboxChange = (event) => {
    SetIsCheckedNoBracket(event.target.checked);
  };


  const handleNoBracketScorecheck = async (tournamentId, matchId) => {
    setValidated(true)

    const data = {
      "matchId": selectedListItem.matchId,
      "tournamentId": tournamentId,
      "playerScore": scoreNoBracket,
      "isCompleted": isCheckedNoBracket
    };


    await TournamentUpdatePlayerMatchScore(data).then(async (res) => {

   
      if (res?.data?.status === true) {
       
        toast.success(res?.data?.message);
        setCount(count + 1);
        setNoBracketshow(false);
        // Fetch updated score data after successful update
      } else {
        toast.error(res?.data?.message);
      }
    });
  };
  const handelNoBracketScoreUpdate = (e) => {
    const newScore = e.target.value;

    setScoreNoBracket(newScore);
  };
  const handleNoBracketClose = () => {
    setNoBracketshow(false)
    setNoBracketshowDate(false)
  };
  const handelDate = (e) => {

    // setDateUpdate(e)
    setStartMatch(e)

  }


  useEffect(() => {
    const fetchTournamentData = async () => {
      if (roundData?.length === 0) {
        const res = await GetTournamentTeamMatch(id);
        setTeamData(res?.data)
      }
    };

    fetchTournamentData();
  }, [count]);


  const scoreNoBracketModel = (listItem, index) => {
    setSelectedListItem(listItem)
    /************** */
    const dateCurrent = dayjs(listItem?.matchStartDate).format("MM/DD/YYYY") === "01/01/1901 T00:00:00"
      ? dayjs().format("MM/DD/YYYY T00:00:00")
      : dayjs(listItem?.matchStartDate).format("MM/DD/YYYY T00:00:00");
    setStartNoBracketMatch(dateCurrent);


    setScoreNoBracket(listItem.playerScore)
    setNoBracketshow(true);
    setTeamDataLen(index)

  };




  const handleDateUpdate = async () => {
    const data =
    {
      "matchId": dataList?.matchId,
      "tournamentId": tournamentIdScore,
      "matchStartDate": startMatch
    }
    await TournamentUpdateTeamDate(data).then((res) => {
      if (res?.status == true) {
        setDateValid(false);
        setStartMatch('')
        // window?.location.reload();
        toast.success(res?.message);
        setCount(count + 1);
        setShowDate(false);
      }
      else {
        toast.error(res?.message);
      }
    })
  }
  const handleClose = () => {
    setShow(false)
    setShowDate(false)
    setIsChecked(false)
  };
  const Bracketfn = async () => {
    await TournamentBarcketId(id).then((res) => {
      setRoundData(res);
    });
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  const handleScorecheck = async () => {

    const leftScore = Number(dataList?.leftTeamScore);
    const rightScore = Number(dataList?.rightTeamScore);

    // Validate that scores are whole numbers
    if (!Number.isInteger(leftScore) || !Number.isInteger(rightScore)) {
      toast.error("Scores should not be decimal number.");
      return; // Exit the function if validation fails
    }

    const data = {
      "matchId": dataList?.matchId,
      "tournamentId": tournamentIdScore,
      "leftTeamScore": Number(dataList?.leftTeamScore),
      "rightTeamScore": Number(dataList?.rightTeamScore),
      "isCompleted": isChecked
    };

    await TournamentUpdateTeamScore(data).then(async (res) => {
      if (res?.status === true) {
   
        toast.success(res?.message);
        setCount(count + 1);
        setShow(false);
        setIsChecked(false)

        // Fetch updated score data after successful update
      } else {
        toast.error(res?.message);

      }
    });
  };

  useEffect(() => {
    Bracketfn();
  }, [count]);
  useEffect(() => {
    const BracketfnGet = async () => {
      await TournamentBarcketId(id).then((res) => {
 
        setScoreData(res)
        setDataListItem(res)
      })
    }
    BracketfnGet()
  }, [count]);

  

  function sidebarfun() {
    setDataSide(!dataSide);
  }
  const handleEditClickTeam = (ind, id) => {
    const selectedMatch = roundData.find(itemList => itemList.matchId === id);
    if (selectedMatch) {
      setFirstMatchIdItem(id)
      setEditModeByIndex(ind);
      // setEditMode(true);
      setRoundMatchData(selectedMatch); // Assuming you have a state to hold matchDetails
    }
  }



  const closebtn = () => {

    setEditModeByIndex(null); // Reset editModeByIndex to null
    setRoundMatchData(null);
  }

  const handelScoreUpdate = (e) => {
    setDataList({
      ...dataList,
      [e.target.name]: e.target.value
    })
  }
  const handelOnChange = (e) => {
    const [value, array] = e.target.value.split(",");
    setSecondsId(array);
    setScondMtachId(value);

  }

  const handleSaveClick = async () => {
    const Updatedata =
    {
      "tournamentId": Number(id),
      "firstTeamMatchId": firstMatchIdItem,
      "firstTeamId": editModeByIndex,
      "secondTeamMatchId": Number(scondMtachId),
      "secondTeamId": Number(secondsId),
    }
    await BracketUpdate(Updatedata).then((res) => {
      if (res?.status == true) {
        Bracketfn();
        toast.success(res?.message);
        setCount(count + 1)
        setEditModeByIndex(null);
      }
      else {
        toast.error(res?.message);
      }
    })
    setEditMode(false);
  }



  const handleShow = (list) => {


 
 
    setDataList(list)
    // setCheckList(true);
    setShow(true);

  }



  function constructPlayers(roundData) {
    const players = {};

    const sortedLevels = [
      ...new Set(roundData.map(({ matchLevel }) => matchLevel)),
    ].sort((a, b) => b - a);

    const levelToRound = {};
    sortedLevels.forEach((level, index) => {
      levelToRound[level] = `round${index + 1}`;
    });

    roundData.forEach(
      ({
        matchLevel,
        leftTeamId,
        rightTeamId,
        leftTeamName,
        rightTeamName,
        // matchId,


      }) => {
        const roundKey = levelToRound[matchLevel];

        if (!players[roundKey]) {
          players[roundKey] = [];
        }

        players[roundKey].push([
          leftTeamId !== 0 ? leftTeamId : "tbd",
          rightTeamId !== 0 ? rightTeamId : "tbd",
          // leftTeamName|| (leftTeamId !== 0 ? leftTeamId : "tbd"),
          // rightTeamName || (rightTeamId !== 0 ? rightTeamId : "tbd"),
          // matchId || (matchId),


        ]);
      }
    );




    return players;
  }


  const playersData = constructPlayers(roundData);

  
  function populateTree(obj) {
    const newObj = JSON.parse(JSON.stringify(obj));

    const roundNumbers = Object.keys(newObj)
      .filter((key) => key.startsWith("round"))
      .map((key) => parseInt(key.replace(/[^\d]/g, ""), 10))
      .filter((num) => !isNaN(num));

    const maxRound = Math.max(...roundNumbers);
    let pointer = maxRound;

    while (pointer > 1) {
      const currRoundKey = `round${pointer}`;
      const prevRoundKey = `round${pointer - 1}`;

      if (!newObj[currRoundKey] || !Array.isArray(newObj[currRoundKey])) {
        pointer--;
        continue;
      }

      const currRound = newObj[currRoundKey].reduce((acc, item) => {
        return Array.isArray(item) ? acc.concat(item) : acc;
      }, []);

      if (!newObj[prevRoundKey] || !Array.isArray(newObj[prevRoundKey])) {
        newObj[prevRoundKey] = [];
      }

      for (let i = 0; i < currRound.length; i++) {
        if (
          currRound[i] !== "tbd" &&
          !newObj[prevRoundKey].some((pair) => pair.includes(currRound[i]))
        ) {
          newObj[prevRoundKey].splice(i, 0, [null, null]);
        }
      }
      pointer--;
    }

    return newObj;
  }

  function connectLines(obj, newLines) {
    const round = Math.max(
      ...Object.keys(obj).map((key) => parseInt(key.replace(/[A-Za-z$-]/g, "")))
    );

    let pointer = round;

    while (pointer !== 1) {
      const currRound = obj[`round${pointer}`];
      const prevRound = obj[`round${pointer - 1}`];

      if (!currRound || !prevRound) {
        pointer--;
        continue;
      }

      for (let i = 0; i < currRound.length; i++) {
        const [teamA, teamB] = currRound[i];

        let teamIndexA = prevRound.findIndex((pair) => pair.includes(teamA));
        let teamIndexB = prevRound.findIndex((pair) => pair.includes(teamB));

        if (teamA !== "tbd" && teamIndexA !== -1) {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${teamIndexA + 1}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }

        if (teamB !== "tbd" && teamIndexB !== -1) {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${teamIndexB + 1}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }

        if (teamA === "tbd") {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${i * 2 + 1}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }
        if (teamB === "tbd") {
          drawConnectorsBetweenMatches(
            `.round${pointer - 1}match${i * 2 + 2}`,
            `.round${pointer}match${i + 1}`,
            newLines
          );
        }
      }
      pointer--;
    }
  }

  const newPlayersData = populateTree(playersData);
  const data = newPlayersData;
  const [lines, setLines] = useState([]);

  function getName(player) {
    if (!player) return "Player";
    if (player === "bye") return "Bye";
    if (player === "tbd") return "TBD";
    return player;
  }

  const drawConnectorsBetweenMatches = (
    match1Selector,
    match2Selector,
    newLines
  ) => {
    const playoffTable = document.querySelector(".playoff-table");
    if (!playoffTable) return;
    const { scrollLeft, offsetTop } = playoffTable;
    const { left: playoffTableLeft } = playoffTable.getBoundingClientRect();

    const match1Elem = document.getElementById(match1Selector);
    const match2Elem = document.getElementById(match2Selector);

    if (!match1Elem || !match2Elem) return;

    const match1Rect = match1Elem.getBoundingClientRect();
    const match2Rect = match2Elem.getBoundingClientRect();

    let midPointX =
      (match1Rect.right + match2Rect.left) / 2 + scrollLeft - playoffTableLeft;

    newLines.push({
      x1: midPointX,
      y1: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
      x2: midPointX,
      y2: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop,
    });
    newLines.push({
      x1: match1Rect.right + scrollLeft - 20 - playoffTableLeft,
      y1: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
      x2: midPointX,
      y2: match1Rect.top + match1Rect.height / 2 + window.scrollY - offsetTop,
    });
    newLines.push({
      x1: match2Rect.left + scrollLeft + 20 - playoffTableLeft,
      y1: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop,
      x2: midPointX,
      y2: match2Rect.top + match2Rect.height / 2 + window.scrollY - offsetTop,
    });
  };

  useEffect(() => {
    if (!data || Object.keys(data).length === 0) return;

    const playoffTable = document.querySelector(".playoff-table");
    const linesOverlay = document.querySelector(".lines-overlay");
    if (!playoffTable || !linesOverlay) return;

    const calculatePositions = () => {
      let newLines = [];
      connectLines(data, newLines);

      // Only update state if newLines is different from the current state
      if (JSON.stringify(newLines) !== JSON.stringify(lines)) {
        setLines(newLines);
      }
    };

    const handleScroll = () => {
      const { scrollLeft, scrollTop } = playoffTable;
      linesOverlay.style.left = `-${scrollLeft}px`;
      linesOverlay.style.top = `-${scrollTop}px`;
    };

    calculatePositions();
    window.addEventListener("resize", calculatePositions);
    playoffTable.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", calculatePositions);
      playoffTable.removeEventListener("scroll", handleScroll);
    };
  }, [data, lines]); // Add lines to the dependency array
  const isUser = JSON.parse(localStorage.getItem('isUser'));



 
  useEffect(() => {
    if (dataList?.matchStartDate) {
      const startDate = new Date(dataList?.matchStartDate);
      const timezoneOffset = startDate.getTimezoneOffset();
      startDate.setMinutes(startDate.getMinutes() - timezoneOffset);
      if (dataList?.matchStartDate === "0001-01-01T00:00:00" || dataList?.matchStartDate === null || dataList?.matchStartDate === "") {

        setStartMatch();
      } else {
        setStartMatch(startDate);
      }

    }
  }, [dataList]);


  useEffect(() => {
    if (teamData[0]?.matchStartDate) {
      const startDate = new Date(teamData[0]?.matchStartDate);
      const timezoneOffset = startDate.getTimezoneOffset();
      startDate.setMinutes(startDate.getMinutes() - timezoneOffset);
      if (teamData[0]?.matchStartDate === "0001-01-01T00:00:00" || teamData[0]?.matchStartDate === null || teamData[0]?.matchStartDate === "") {
        // const dateItem = new Date();
        // setDateUpdate(dateItem);
      } else {
        setDateUpdate(startDate);
      }

    }
  }, [teamData]);




  const handleShowDate = (list) => {
    setShowDate(true)
    setDataList(list)
  }

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const scoreNoBracketModelDate = () => {
    setNoBracketshowDate(true)
  }


  const localTime = dayjs(teamData[0]?.matchStartDate + "Z").format("MM/DD/YYYY hh:mm:ss A");

  const tournamentNames = roundData?.map(item => item.tournamentName);
  const tournamentStart = roundData?.map(item => dayjs(item?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));

  const firstStartDate = tournamentStart[0]
  const tournamentendDate = roundData?.map(item => dayjs(item?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));
  const firstEndDate = tournamentendDate[0]
  const firstTournamentName = tournamentNames[0];


  const tournamentNames1 = teamData?.map(item => item.tournamentName);
  const tournamentStart1 = teamData?.map(item => dayjs(item?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));
  const tournamentendDate1 = teamData?.map(item => dayjs(item?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A"));
  const firstStartDate1 = tournamentStart1[0]
  const firstEndDate1 = tournamentendDate1[0]
  const firstTournamentName1 = tournamentNames1[0];

  return (
    <>

      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group1" >
      <Sidebar data={dataSide} />
      <div className="testbracket">
        <div
          className={
            dataSide ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >


          {roundData?.length > 0 ?
            <>

              <h4 className="mb-3 text-dark text-breacket-heading">
                Contest Name: <span className="text-primary text-name-tourna">{firstTournamentName}</span> Contest Start Date : <span className="text-primary text-name-tourna">{firstStartDate}</span>Contest End Date : <span className="text-primary text-name-tourna">{firstEndDate}</span>
              </h4>

            </> :

            <>

              <h4 className="mb-3 text-dark">
                Contest Name: <span className="me-5 text-primary">{firstTournamentName1}</span>Contest Start Date : <span className="me-5 text-primary">{firstStartDate1}</span>Contest End Date : <span className="me-5 text-primary">{firstEndDate1}</span>
              </h4>

            </>
          }



          <div class="bracket  disable-image bg-white">

            <Modal show={show} onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Update Teams Score</Modal.Title>
              </Modal.Header>
              <Modal.Body>




                {
                  dataList?.leftTeamName == null ?

                    <Form.Group as={Row} className="" >
                      <Form.Label column sm="2" className='p-0'>

                        <Form.Control
                          required
                          type="number"
                          disabled
                          name="leftTeamScore"
                          value={dataList?.leftTeamScore == null ? 0 : dataList?.leftTeamScore}
                          maxLength={50}
                          onChange={handelScoreUpdate}

                        />
                      </Form.Label>
                      <Col sm="10">
                        <Form.Control type="text" disabled value={dataList?.leftTeamName} />
                      </Col>

                    </Form.Group>



                    :
                    <Form.Group as={Row} className="" >
                      <Form.Label column sm="2" className='p-0'>

                        <Form.Control
                          required
                          type="number"
                          name="leftTeamScore"
                          value={dataList?.leftTeamScore == null ? 0 : dataList?.leftTeamScore}
                          maxLength={50}
                          onChange={handelScoreUpdate}

                        />
                      </Form.Label>
                      <Col sm="10">
                        <Form.Control type="text" value={dataList?.leftTeamName} />
                      </Col>

                    </Form.Group>
                }
                {
                  dataList?.rightTeamName == null ?
                    <Form.Group as={Row} className="" >
                      <Form.Label column sm="2" className='p-0'>

                        <Form.Control
                          required
                          type="number"
                          disabled
                          name="rightTeamScore"
                          value={dataList?.rightTeamScore == null ? 0 : dataList?.rightTeamScore}
                          maxLength={50}
                          onChange={handelScoreUpdate}

                        />

                      </Form.Label>
                      <Col sm="10">
                        <Form.Control type="text" disabled value={dataList?.rightTeamName} />
                      </Col>
                    </Form.Group> :
                    <Form.Group as={Row} className="" >
                      <Form.Label column sm="2" className='p-0'>

                        <Form.Control
                          required
                          type="number"
                          name="rightTeamScore"
                          value={dataList?.rightTeamScore == null ? 0 : dataList?.rightTeamScore}
                          maxLength={50}
                          onChange={handelScoreUpdate}

                        />

                      </Form.Label>
                      <Col sm="10">
                        <Form.Control type="text" value={dataList?.rightTeamName} />
                      </Col>
                    </Form.Group>
                }


                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                  <Form.Check type="checkbox" checked={isChecked}
                    onChange={handleCheckboxChange} label="Match Completed" />
                </Form.Group>

                {/* <p>By Proceeding, you will not be able to update scores again.</p> */}


                <Button variant="success" onClick={handleScorecheck}>
                  Submit
                </Button>





              </Modal.Body>
              <Modal.Footer>

              </Modal.Footer>
            </Modal>

            <Modal show={showDate} centered onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Update Match Start Date </Modal.Title>
              </Modal.Header>
              <Modal.Body>



          
                <Form.Group as={Row} className="mb-3" >

                 

                  <DatePicker
                    placeholder="Select Match start Date"
                    format="MM/dd/yyyy hh:mm:ss aa"
                    showMeridian
                    value={startMatch}
                    disabledDate={(date) => firstStartDate && dayjs(date).isBefore(firstStartDate,'day')}
                 
                    onChange={handelDate}
                    name="matchStartDate"
                    className='Auction-Date'
                  />
                </Form.Group>
                <Button variant="success" onClick={handleDateUpdate}>
                  Submit
                </Button>
              </Modal.Body>
              <Modal.Footer>
              </Modal.Footer>
            </Modal>

            {roundData.length === 0 ? (<>

              <Card className='p-3'>
                <Row>
                  {
                    teamData?.length > 0 ? <> <Col md="6">
                      <h5>Player List - <span className='text-danger'>The highest score will be the winner !</span></h5>

                    </Col>
                      <Col md="6" className="text-right">

                        <div className='dateMatachUpdate'>
                          <div className="date update">
                            {
                              teamData[0]?.matchStartDate === "0001-01-01T00:00:00"
                                ? <p>Select Match Start Date</p>
                                : localTime
                            }

                            {teamData[0]?.isCompleted == true ? <Button variant='success' disabled className='ms-3 placebid disable' onClick={() => scoreNoBracketModelDate(teamData[0])} ><icons.Pencil></icons.Pencil> </Button> : <Button variant='success' className='ms-3' onClick={() => scoreNoBracketModelDate(teamData[0])} ><icons.Pencil></icons.Pencil> </Button>
                            }
                          </div>
                        </div>
                        {/* <hr></hr> */}

                        {
                          teamData?.map((listItem) => <>
                            <Modal show={noBracketshowDate} onHide={handleNoBracketClose}>
                              <Modal.Header closeButton>
                                <Modal.Title>Update Match Start Date  </Modal.Title>
                              </Modal.Header>
                              <Modal.Body>


                             
                                <Form validated={validated}>
                                  <Form.Group as={Row} className="mb-3" >
                                    <DatePicker
                                      placeholder="Select Match Start Date"
                                      format="MM/dd/yyyy hh:mm:ss aa"
                                      showMeridian
                                      disabledDate={(date) => firstStartDate1 && dayjs(date).isBefore(firstStartDate1)}
                                      value={dateUpdate}
                                      onChange={handelNoBracketDate}
                                      name="matchStartDate"
                                      className='Auction-Date'
                                      required
                                    />

                                    <Form.Control.Feedback type="invalid" style={{ display: dateValid ? 'none' : 'block' }}>
                                      Please select the match start date and time.
                                    </Form.Control.Feedback>
                                  </Form.Group>

                                  <Button variant="success" onClick={() => handleNoBracketDateUpdate(listItem.tournamentId)}>
                                    Submit
                                  </Button>
                                </Form>


                              </Modal.Body>

                            </Modal>

                          </>)

                        }

                      </Col>
                    </>
                      : ""
                  }


                </Row>



                <ListGroup variant="flush" class="list-item-player">
                  {
                    teamData?.map((listItem, index) => <ListGroup.Item>
                      <div className='score-player-name'>

                        <h5> <span className='text-score-update'>{listItem.playerScore}  </span> {listItem?.playerName}  </h5>
                      </div>

                      <div className='score-date-edit'>
                        {
                          listItem?.isCompleted == true ? <Button variant='success' disabled className='ms-3 placebid disable' onClick={() => scoreNoBracketModel(listItem)} ><icons.Pencil></icons.Pencil></Button> : <Button variant='success' className='ms-3' onClick={() => scoreNoBracketModel(listItem, index)} ><icons.Pencil></icons.Pencil></Button>
                        }

                      </div>




                      <Modal show={noBracketshow} onHide={handleNoBracketClose}>
                        <Modal.Header closeButton>
                          <Modal.Title>Update Teams Score</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form validated={validated}>
                            <Form.Group controlId="validationCustom01">
                              <Form.Control
                                required
                                type="number"
                                maxLength={50}
                                name="rightTeamScore"
                                value={scoreNoBracket}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (value >= 0 || value === '') {
                                    handelNoBracketScoreUpdate(e);
                                  }
                                }}
                              />
                              <Form.Control.Feedback type="invalid">
                                Please enter a score.
                              </Form.Control.Feedback>
                            </Form.Group>
                            {teamDataLen === teamData.length - 1 ? (
                              <Form.Group controlId="formBasicCheckbox">
                                <Form.Check
                                  type="checkbox"
                                  checked={isCheckedNoBracket}
                                  onChange={handleNoBracketCheckboxChange}
                                  label="Match Completed"
                                />
                              </Form.Group>
                            ) : ""
                            }


                            <Button className="mt-3" variant="success" onClick={() => handleNoBracketScorecheck(listItem.tournamentId)}>
                              Submit
                            </Button>
                          </Form>


                        </Modal.Body>

                      </Modal>

                    </ListGroup.Item>)

                  }

                </ListGroup>
              </Card>


            </>) : (
              <>




                <h5 className="p-3 "><span className="text-danger">*</span> You can Shuffle teams using <button><icons.Shuffle className='suffle-icon' /></button> icon and hit <button><icons.Save2 className='save-icon' /> </button> icon after completion</h5>
                <div className="playoff-table">

                  <div className="playoff-table-content">

                    {
                      Object.keys(data).map((roundKey, roundIndex) => (
                        <div key={roundKey} className="playoff-table-tour">
                          {data[roundKey].map((pair, index) => {
                            const matchDetails = roundData.sort((a, b) => b.matchLevel - a.matchLevel).find((match) => (match.leftTeamId === pair[0] && (match.rightTeamId === pair[1] || match.rightTeamId === 0)) || (match.rightTeamId === pair[1] && match.leftTeamId === 0));
                      
                            const localTime = convertUTCToLocalTime(matchDetails?.matchStartDate + "Z");
                            const dayjsDate = dayjs(localTime);
                            const formattedDate = dayjsDate.format("MM/DD/YYYY");
                            const timePart = dayjsDate.format("hh:mm:ss A");
                            return (
                              <>
                                <div
                                  key={index}
                                  id={`.round${roundIndex + 1}match${index + 1}`}
                                  className={`playoff-table-group round${roundIndex + 1}match${index + 1}`}
                                >

                                  <div className={`playoff-table-pair playoff-table-pair-style ${!pair[0] && !pair[1] ? "playoff-table-pair--empty" : ""}`}>
                                    {
                                      matchDetails?.matchStartDate ? (
                                        <div className="dateUpdate">
                                          {matchDetails.matchStartDate === "0001-01-01T00:00:00" ? (
                                            <div>
                                              Select Match Start Date
                                              {!matchDetails.isCompleted && matchDetails.createdBy === isUser?.userId && (
                                                <button
                                                  className="saveDate"
                                                  onClick={() => handleShowDate(matchDetails)}
                                                >
                                                  <icons.PencilSquare className="editpencil" />
                                                </button>
                                              )}
                                            </div>
                                          ) : (
                                            <span>
                                              {dayjs(matchDetails.matchStartDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}
                                              {!matchDetails.isCompleted && matchDetails.createdBy === isUser?.userId && (
                                                <button
                                                  className="saveDate"
                                                  onClick={() => handleShowDate(matchDetails)}
                                                >
                                                  <icons.PencilSquare className="editpencil" />
                                                </button>
                                              )}
                                            </span>
                                          )}
                                        </div>
                                      ) : ""
                                    }

                                    <div className="playoff-table-left-player">
                                      {
                                        matchDetails?.leftTeamName ? <span className='back-count'>
                                          <p>{matchDetails?.leftTeamScore}</p>
                                        </span> : <span className='back-count opictity'>
                                          <p>{matchDetails?.leftTeamScore}</p>
                                        </span>
                                      }

                                      {
                                        editModeByIndex === matchDetails?.leftTeamId ? (
                                          <select className="selectbox-suff" onChange={handelOnChange}>
                                            <option>Select </option>
                                            {roundData?.map((itemList, i) => {
                                              return (
                                                <>
                                                  {
                                                    itemList.leftTeamId === 0 && itemList.rightTeamId === 0 ? null : (
                                                      <>
                                                        {itemList.leftTeamId !== 0 && (
                                                          <option value={`${itemList.matchId}, ${itemList.leftTeamId}`}>
                                                            {itemList.leftTeamName}
                                                          </option>
                                                        )}
                                                        {itemList.rightTeamId !== 0 && (
                                                          <option value={`${itemList.matchId}, ${itemList.rightTeamId}`}>
                                                            {itemList.rightTeamName}
                                                          </option>
                                                        )}
                                                      </>
                                                    )
                                                  }
                                                </>
                                              )

                                            })}
                                          </select>
                                        ) : (
                                          <>
                                            {
                                              matchDetails?.leftTeamId ? <span className='team-list-name'>{matchDetails?.leftTeamName} </span> : <p className="tbdText">TBD</p>
                                            }

                                            {
                                              matchDetails?.winnerTeamId === matchDetails?.leftTeamId && matchDetails?.isCompleted === true ? <img src="/image/trophy1.png" className="me-2 suffle1"></img> : ""
                                            }
                                          </>
                                        )

                                      }

                                      {
                                        editModeByIndex === matchDetails?.leftTeamId ? (<>
                                          <button onClick={handleSaveClick}><icons.Save2 className='save-icon' /> </button>
                                          <button ><icons.XLg onClick={closebtn} /></button></>
                                        ) : (
                                          <>
                                            {/* {
                                              matchDetails?.leftTeamId ? matchDetails?.createdBy !== isUser?.userId ? <button disabled className='suffle disable ms-2' onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}><icons.Shuffle className='suffle-icon' /> </button> : <button className="ms-2 suffle" onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}><icons.Shuffle className='suffle-icon' /> </button> : ""
                                            } */}

                                            {
                                              matchDetails?.winnerTeamId === matchDetails?.leftTeamId || matchDetails?.isCompleted === true ? null : (
                                                matchDetails?.leftTeamName ? (
                                                  matchDetails?.createdBy !== isUser?.userId ? (
                                                    <button disabled className='suffle disable ms-2' onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    </button>
                                                  ) : (
                                                    <button className="ms-2 suffle" onClick={() => handleEditClickTeam(matchDetails.leftTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    </button>
                                                  )
                                                ) : null
                                              )
                                            }

                                          </>

                                        )

                                      }
                                    </div>
                                    <div className="playoff-table-right-player">
                                      {
                                        matchDetails?.rightTeamName ?
                                          <span className='back-count1'>
                                            <p>{matchDetails?.rightTeamScore}</p>
                                          </span> : <span className='back-count opictity'>
                                            <p>{matchDetails?.rightTeamScore}</p>
                                          </span>
                                      }
                                      {
                                        editModeByIndex === matchDetails?.rightTeamId ? (
                                          <select className="selectbox-suff" onChange={handelOnChange}>
                                            <option>Select </option>
                                            {roundData?.map((itemList, i) => {
                                              return (
                                                <>
                                                  {
                                                    itemList.leftTeamId === 0 && itemList.rightTeamId === 0 ? null : (
                                                      <>
                                                        {itemList.leftTeamId !== 0 && (
                                                          <option value={`${itemList.matchId}, ${itemList.leftTeamId}`}>
                                                            {itemList.leftTeamName}
                                                          </option>
                                                        )}
                                                        {itemList.rightTeamId !== 0 && (
                                                          <option value={`${itemList.matchId}, ${itemList.rightTeamId}`}>
                                                            {itemList.rightTeamName}
                                                          </option>
                                                        )}
                                                      </>
                                                    )
                                                  }
                                                </>
                                              )

                                            })}
                                          </select>
                                        ) : (
                                          <>

                                            {
                                              matchDetails?.rightTeamName ? <span className='team-list-name'>{matchDetails?.rightTeamName}

                                              </span> : <p className="tbdText">TBD</p>
                                            }
                                            {
                                              matchDetails?.winnerTeamId === matchDetails?.rightTeamId && matchDetails?.isCompleted === true ? <img src="/image/trophy1.png" className="me-2 suffle1"></img> : ""
                                            }
                                          </>
                                        )

                                      }


                                      {
                                        editModeByIndex === matchDetails?.rightTeamId ? (<>
                                          <button onClick={handleSaveClick}><icons.Save2 className='save-icon' /> </button>
                                          <button ><icons.XLg onClick={closebtn} /></button></>
                                        ) : (
                                          <>
                                            {
                                              matchDetails?.winnerTeamId === matchDetails?.rightTeamId || matchDetails?.isCompleted === true ? null : (
                                                matchDetails?.rightTeamName ? (
                                                  matchDetails?.createdBy !== isUser?.userId ? (
                                                    <button disabled className='suffle disable ms-2' onClick={() => handleEditClickTeam(matchDetails.rightTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    </button>
                                                  ) : (
                                                    <button className="ms-2 suffle" onClick={() => handleEditClickTeam(matchDetails.rightTeamId, matchDetails?.matchId)}>
                                                      <icons.Shuffle className='suffle-icon' />
                                                    </button>
                                                  )
                                                ) : null
                                              )
                                            }
                                          </>

                                        )

                                      }
                                    </div>

                                    {
                                      matchDetails?.isCompleted === false && matchDetails?.createdBy === isUser?.userId ? (
                                        <button className='saveScoreBtn' onClick={() => handleShow(matchDetails)}>Score</button>
                                      ) : (
                                        <button className='saveScoreBtn disable' disabled onClick={() => handleShow(matchDetails)}>Score</button>
                                      )
                                    }
                                  </div>
                                </div>
                              </>
                            );
                          })}
                        </div>
                      ))
                    }        <svg className="lines-overlay">
                      {lines.map((line, index) => (
                        <line
                          key={index}
                          x1={line.x1}
                          y1={line.y1}
                          x2={line.x2}
                          y2={line.y2}
                          stroke="black"
                        />
                      ))}
                    </svg>
                  </div>
                </div>
              </>)}
          </div>

        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </div>
    </>
  );
};
